import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import PlusIcon from "src/components/icons/Plus";
import { ApplicationStore } from "src/store";
import { getAccessoriesTotal } from "src/store/selectors/accessories";
import { localizeCurrencyWithDecimals } from "src/utils";
import useSelector from "src/utils/useSelector";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

const Cell = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 1em 0.5em 1em 1em;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        padding: 1em;
    }
`;
const Button = styled("button")`
    background: none;
    border: none;
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    font-size: 1em;
    outline: 0;
    padding: 0;
`;
const ButtonIcon = styled(PlusIcon)`
    color: ${(props) => props.theme.palette.primary.main};
    height: 15px;
    width: 15px;
`;
interface Props {
    vin: string;
}

const AccessoriesCell = ({
    total,
    vin,
    isOpen,
    toggleDrawer,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const location = useLocation<{ vin?: string }>();
    const label = useSelector((state) => state.account?.account_disclaimers?.upgrades_label);

    const handleToggle = () => {
        if (!isOpen || (location.pathname === `/my-garage/accessories` && location.state?.vin === vin)) {
            toggleDrawer();
        }
    };

    return (
        <Link
            to={{
                pathname:
                    isOpen && location.state?.vin === vin && location.pathname === `/my-garage/accessories`
                        ? `/my-garage`
                        : `/my-garage/accessories`,
                ...(isOpen && location.state?.vin === vin && location.pathname === `/my-garage/accessories`
                    ? {}
                    : { state: { vin } }),
            }}
            onClick={() => handleToggle()}
            style={{ color: "inherit", height: "100%", width: "100%" }}
            title={label}
        >
            <Cell>
                <span>{localizeCurrencyWithDecimals(total)}</span>
                <Button className="clickable">
                    <ButtonIcon />
                </Button>
            </Cell>
        </Link>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    return {
        total: getAccessoriesTotal(state, vin),
        isOpen: state.onlineShopper.isDrawerOpen,
    };
};
const mapDispatchToProps = { toggleDrawer: toggleGarageDrawer };

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesCell);
